module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "name": "fade"
    }
  }, [_c('div', {
    attrs: {
      "id": "priceNotifier"
    }
  }, [_vm._v("\n \t\tPriset har uppdaterats\n \t")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5681c1da!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/PriceNotifier.vue
// module id = 158
// module chunks = 0